import { App } from 'vue';

declare const STAGE: string;

export default {
	install: (app: App<Element>): void => {
		const rollbarConfig = {
			accessToken: '3a4a39800e054546b7ad8d50add5872d',
			captureUncaught: false,
			captureUnhandledRejections: false,
			payload: {
				environment: STAGE
			},
			checkIgnore: window['rollbarIgnore']
		};

		const rollbar =
			window && window['rollbar'] && window['rollbarIgnore'] ? new window['rollbar'](rollbarConfig) : null;

		app.config.errorHandler = (error: any): void => {
			if (rollbar === null) {
				return;
			}

			if (STAGE === 'production') {
				rollbar.error(error);
			}

			throw error;
		};
	}
};
